<template>
  <div class="aobang-result">
    <div class="banner-section">
      <img class="banner-img" src="/static/images/aobang/banner.png" alt="aobang-banner">
    </div>
    <div class="exchange-card" @click="handleExchangeClick">
      <img class="exchange-bg" src="/static/images/aobang/dh-bg.png" alt="exchange-bg">
      <img class="exchange-sales" src="/static/images/aobang/sales.png" alt="sales">
      <div class="exchange-content">
        <img class="exchange-v" src="/static/images/aobang/v2.png" alt="v-mark">
        <div class="exchange-main">
          <img class="exchange-tip" src="/static/images/aobang/duihuan-tip.png" alt="积分兑换">
          <div class="exchange-btn">
            立即兑换
            <svg class="exchange-btn-arrow" viewBox="0 0 8 10" aria-hidden="true">
              <path d="M0 0L8 5L0 10V0Z" fill="#5562ee" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <wx-open-launch-weapp
      class="shop-entry"
      :appid="miniAppId"
      :username="miniAppOriginalId"
      :path="miniAppPage"
    >
      <script type="text/wxtag-template">
        <div style="width:100%;height:100%;padding:0 clamp(14px, 4.8vw, 18px) 0 clamp(8px, 2.2vw, 10px);border-radius:clamp(14px, 4vw, 15px);background:rgb(67, 86, 222);display:flex;align-items:center;box-sizing:border-box;color:#fff;">
          <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/aobang/gouwu.png" alt="购物车" style="width:clamp(48px, 14vw, 54px);height:clamp(48px, 14vw, 54px);object-fit:contain;flex-shrink:0;">
          <span style="flex:1;text-align:center;font-size:clamp(15px, 4.8vw, 17px);font-weight:600;letter-spacing:0.06em;">进入积分商城</span>
          <span style="width:clamp(12px, 3.8vw, 14px);height:clamp(12px, 3.8vw, 14px);margin-right:clamp(4px, 1.8vw, 8px);border-top:clamp(2px, 0.8vw, 3px) solid #fff;border-right:clamp(2px, 0.8vw, 3px) solid #fff;transform:rotate(45deg);flex-shrink:0;"></span>
        </div>
      </script>
    </wx-open-launch-weapp>
    <div class="company-section">
      <img class="company-bg" src="/static/images/aobang/gate.png" alt="company-bg">
      <img class="company-heart" src="/static/images/aobang/heart.png" alt="heart">
      <div class="company-info-card">
        <div class="company-name">北京中生奥邦生物科技有限公司</div>
        <div class="company-info-row">
          <img class="company-info-icon" src="/static/images/aobang/mobile.png" alt="mobile">
          <span>电话:400-888-1804</span>
        </div>
        <div class="company-info-row">
          <img class="company-info-icon" src="/static/images/aobang/mail.png" alt="mail">
          <span>邮件:sales-china@eallbio.com</span>
        </div>
        <div class="company-info-row company-info-row-address">
          <img class="company-info-icon" src="/static/images/aobang/address.png" alt="address">
          <span>地址:北京市大兴区中关村生物医药产业基地永兴路28号院</span>
        </div>
      </div>
      <img class="company-watch" src="/static/images/aobang/watch.png" alt="watch">
    </div>
    <div v-if="showRewardClaimedModal" class="reward-claimed-modal-mask" @click="closeRewardClaimedModal">
      <div class="reward-claimed-modal" @click.stop>
        <div class="reward-claimed-modal-body">
          <img class="reward-claimed-modal-v" src="/static/images/aobang/v.png" alt="claimed-modal-v">
          <div class="reward-claimed-modal-content">
            <img class="reward-claimed-modal-sorry" src="/static/images/aobang/sorry.png" alt="抱歉">
            <img class="reward-claimed-modal-text" src="/static/images/aobang/jfyblq.png" alt="积分奖励已被领取">
            <wx-open-launch-weapp
              class="reward-claimed-modal-btn"
              :appid="miniAppId"
              :username="miniAppOriginalId"
              :path="miniAppPage"
            >
              <script type="text/wxtag-template">
                <img
                  src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/aobang/blue-qwsc-ab.png"
                  alt="前往积分商城"
                  style="display:block;width:100%;height:100%;"
                >
              </script>
            </wx-open-launch-weapp>
            <img class="reward-claimed-modal-rule-tip" src="/static/images/aobang/rule-tip.png" alt="积分使用规则说明" @click="openPointsRuleFromRewardClaimed">
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPointsClaimModal" class="points-claim-modal-mask" @click="closePointsClaimModal">
      <div class="points-claim-modal" @click.stop>
        <div class="points-claim-modal-body">
          <img class="points-claim-modal-v" src="/static/images/aobang/v.png" alt="claim-modal-v">
          <div class="points-claim-modal-content">
            <img class="points-claim-modal-message" src="/static/images/aobang/gx.png" alt="恭喜获得积分奖励">
            <div class="points-claim-modal-score">
              <span class="points-claim-modal-score-value">{{ pointsValue }}</span>
              <span class="points-claim-modal-score-unit">积分</span>
            </div>
            <wx-open-launch-weapp
              class="points-claim-modal-btn"
              :appid="miniAppId"
              :username="miniAppOriginalId"
              :path="miniAppPage"
            >
              <script type="text/wxtag-template">
                <img
                  src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/aobang/go-shop-ab.png"
                  alt="前往积分商城"
                  style="display:block;width:100%;height:100%;"
                >
              </script>
            </wx-open-launch-weapp>
            <img class="points-claim-modal-rule-tip" src="/static/images/aobang/rule-tip.png" alt="积分使用规则说明" @click="openPointsRuleFromPointsClaim">
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPointsRuleModal" class="points-rule-modal-mask" @click="closePointsRuleModal">
      <div class="points-rule-modal" @click.stop>
        <button class="points-rule-modal-close" type="button" @click="closePointsRuleModal" aria-label="关闭规则说明"></button>
        <div class="points-rule-modal-header">
          <img class="points-rule-modal-header-img" src="/static/images/aobang/rule-sm.png" alt="积分规则说明">
        </div>
        <div class="points-rule-modal-body">
          <img class="points-rule-modal-body-img" src="/static/images/aobang/rule.png" alt="积分规则内容">
        </div>
      </div>
    </div>
    <div v-if="showCodeErrorModal" class="code-error-modal-mask">
      <div class="code-error-modal">
        <div class="code-error-modal-body">
          <img class="code-error-modal-v" src="/static/images/aobang/v.png" alt="error-modal-v">
          <div class="code-error-modal-content">
            <div class="code-error-modal-title">码信息查询异常</div>
            <div class="code-error-modal-desc">请稍后再试</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAntiResult, getJSSDK, getScoreConfig, getTemplate, registerByOpenId, joinActivity, getWechatAuth } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'AobangResult',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138345713227' : '138507280742',
      appId: process.env.ENV_NUM === '1' ? 'wxf35318194cfab96f' : 'wxbc22565b3e7a59fd',
      rawCode: '',
      antiCode: '',
      deptId: '',
      scoreConfig: null,
      yzShopId: '',
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      activityId: '',
      authCode: '',
      userToken: '',
      pointsValue: '',
      showRewardClaimedModal: false,
      showPointsClaimModal: false,
      showPointsRuleModal: false,
      showCodeErrorModal: false
    }
  },
  methods: {
    openCodeErrorModal() {
      this.showCodeErrorModal = true
      document.body.style.overflow = 'hidden'
    },
    async queryAntiResult(code) {
      const res = await getAntiResult(code)
      return res && res.data ? res.data : {}
    },
    async queryScoreConfig() {
      const res = await getScoreConfig(this.deptId)
      this.scoreConfig = res && res.data && res.data.data ? res.data.data : null
      if (this.scoreConfig) {
        this.yzShopId = this.scoreConfig.yzShopId || ''
        this.shopUrl = this.scoreConfig.shopUrl || ''
        const shopUrlParts = this.shopUrl ? this.shopUrl.split('|') : []
        this.miniAppId = shopUrlParts[0] || ''
        this.miniAppOriginalId = shopUrlParts[1] || ''
        this.miniAppPage = shopUrlParts[2] || ''
      }
      console.log('Aobang queryScoreConfig result:', this.scoreConfig)
      return this.scoreConfig
    },
    async queryTemplate() {
      const res = await getTemplate(this.deptId)
      this.activityId = res && res.data && res.data.data ? res.data.data.activityId : ''
      console.log('Aobang queryTemplate result:', this.activityId)
      return this.activityId
    },
    async registerUser() {
      const res = await registerByOpenId(this.eno, this.authCode)
      if (res && res.data && res.data.code === '200' && res.data.data && res.data.data.token) {
        this.userToken = res.data.data.token
        console.log('Aobang registerByOpenId result:', res.data)
        return this.userToken
      }
      alert(res && res.data && res.data.message ? res.data.message : '用户注册失败，请稍后重试')
      return ''
    },
    async joinCurrentActivity() {
      const data = {
        code: this.antiCode,
        activityId: this.activityId,
        authCode: this.authCode,
        userToken: this.userToken
      }
      const res = await joinActivity(data)
      console.log('Aobang joinActivity result:', res && res.data ? res.data : res)
      if (res && res.data && res.data.code === '200') {
        const joinData = res.data.data
        if (Array.isArray(joinData) && joinData.length > 0) {
          this.pointsValue = joinData[0] && joinData[0].giftValue !== undefined ? String(Math.round(joinData[0].giftValue)) : ''
        } else if (joinData && joinData.giftValue !== undefined) {
          this.pointsValue = String(Math.round(joinData.giftValue))
        } else {
          this.pointsValue = ''
        }
        this.openPointsClaimModal()
      } else if (res && res.data && res.data.code === '500001') {
        this.openRewardClaimedModal()
      } else if (res && res.data && res.data.code === '500') {
        alert('系统异常，请稍后重试')
      } else {
        alert(res && res.data && res.data.message ? res.data.message : '参与活动失败，请稍后重试')
      }
    },
    startExchangeAuth() {
      const redirectUrl = window.location.origin + this.$route.path
      const params = new URLSearchParams()
      params.append('c', this.rawCode)
      const fullRedirectUrl = redirectUrl + '?' + params.toString()
      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data
        window.location.href = data
      }).catch(err => {
        alert('获取微信授权失败' + err)
      })
    },
    async initQuery(code) {
      try {
        const data = await this.queryAntiResult(code)
        console.log('Aobang initQuery result:', data)
        if (data.code === '300101' || data.code === '300102') {
          if (data.data) {
            this.deptId = data.data.deptId || ''
            this.antiCode = data.data.code || this.antiCode
          }
        }
        if (data.code === '500' || data.code === '300106') {
          this.openCodeErrorModal()
        }
      } catch (err) {
        console.log('Aobang initQuery error:', err)
        this.openCodeErrorModal()
      }
    },
    async handleExchangeClick() {
      if (!this.deptId) {
        this.openCodeErrorModal()
        return
      }
      if (!this.miniAppId || !this.miniAppOriginalId || !this.miniAppPage) {
        await this.queryScoreConfig()
      }
      await this.queryTemplate()
      if (!this.activityId) {
        alert('暂无可参与的活动，请关注后续活动信息')
        return
      }
      if (!this.authCode) {
        this.startExchangeAuth()
        return
      }
      const userToken = await this.registerUser()
      if (!userToken) {
        return
      }
      await this.joinCurrentActivity()
    },
    openRewardClaimedModal() {
      this.showRewardClaimedModal = true
      document.body.style.overflow = 'hidden'
    },
    openPointsClaimModal() {
      this.showPointsClaimModal = true
      document.body.style.overflow = 'hidden'
    },
    openPointsRuleFromRewardClaimed() {
      this.showRewardClaimedModal = false
      this.showPointsRuleModal = true
      document.body.style.overflow = 'hidden'
    },
    openPointsRuleFromPointsClaim() {
      this.showPointsClaimModal = false
      this.showPointsRuleModal = true
      document.body.style.overflow = 'hidden'
    },
    closePointsRuleModal() {
      this.showPointsRuleModal = false
      document.body.style.overflow = ''
    },
    closePointsClaimModal() {
      this.showPointsClaimModal = false
      document.body.style.overflow = ''
    },
    closeRewardClaimedModal() {
      this.showRewardClaimedModal = false
      document.body.style.overflow = ''
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        })
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
      }).catch(err =>
        alert('获取微信授权失败' + err)
      )
    }
  },
  async mounted() {
    var params = this.$route.query
    this.rawCode = params.c || ''
    this.antiCode = params.c || ''
    this.authCode = params.wyAuthCode || ''
    if (!params.c) {
      this.openCodeErrorModal()
    } else {
      await this.initQuery(params.c)
      if (this.deptId) {
        await this.queryScoreConfig()
      }
    }
    this.getWxJs()
    if (params.c && this.authCode) {
      await this.handleExchangeClick()
    }
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.aobang-result {
  --page-padding: clamp(12px, 4.2vw, 16px);
  --card-radius: clamp(14px, 4.3vw, 16px);
  --section-gap: clamp(14px, 4.8vw, 18px);
  --modal-height: clamp(300px, 88vw, 322px);
  min-height: 100vh;
  padding: var(--page-padding) var(--page-padding) 0;
  background: #fff;
  box-sizing: border-box;
}

.banner-section {
  width: 100%;
}

.banner-img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: var(--card-radius);
}

.exchange-card {
  position: relative;
  margin-top: var(--section-gap);
  width: 100%;
  border-radius: var(--card-radius);
  overflow: hidden;
  cursor: pointer;
}

.exchange-bg {
  display: block;
  width: 100%;
  height: auto;
}

.exchange-sales {
  position: absolute;
  left: 4.5%;
  bottom: clamp(8px, 2vw, 12px);
  width: 40%;
  max-width: clamp(148px, 48vw, 180px);
}

.exchange-content {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 5.5%;
  width: 42%;
}

.exchange-v {
  position: absolute;
  top: 7%;
  right: 0;
  width: 38%;
  min-width: clamp(44px, 13vw, 50px);
  margin-right: clamp(-6px, -1.6vw, -2px);
}

.exchange-main {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.exchange-tip {
  width: 100%;
}

.exchange-btn {
  margin-top: clamp(8px, 2.8vw, 10px);
  padding: 0 clamp(14px, 4.6vw, 18px);
  height: clamp(24px, 6.8vw, 28px);
  border: none;
  border-radius: 999px;
  background: #fff;
  color: rgb(67, 86, 222);
  font-size: clamp(12px, 3.2vw, 13px);
  font-weight: 600;
  line-height: clamp(24px, 6.8vw, 28px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 14px rgba(85, 98, 238, 0.18);
}

.exchange-btn-arrow {
  width: clamp(7px, 2vw, 9px);
  height: clamp(9px, 2.5vw, 11px);
  margin-left: clamp(5px, 1.4vw, 6px);
  display: block;
  flex-shrink: 0;
}

.shop-entry {
  width: 100%;
  margin-top: var(--section-gap);
  height: clamp(50px, 14vw, 54px);
  display: block;
  border-radius: clamp(14px, 4vw, 15px);
  background: rgb(67, 86, 222);
  overflow: hidden;
  box-sizing: border-box;
  line-height: 0;
  font-size: 0;
  box-shadow: 0 8px 16px rgba(77, 91, 238, 0.18);
}

.shop-entry-cart {
  width: clamp(48px, 14vw, 54px);
  height: clamp(48px, 14vw, 54px);
  object-fit: contain;
  flex-shrink: 0;
}

.shop-entry-text {
  flex: 1;
  text-align: center;
  font-size: clamp(15px, 4.8vw, 17px);
  font-weight: 600;
  letter-spacing: 0.06em;
}

.shop-entry-arrow {
  width: clamp(12px, 3.8vw, 14px);
  height: clamp(12px, 3.8vw, 14px);
  margin-right: clamp(4px, 1.8vw, 8px);
  border-top: clamp(2px, 0.8vw, 3px) solid #fff;
  border-right: clamp(2px, 0.8vw, 3px) solid #fff;
  transform: rotate(45deg);
  flex-shrink: 0;
}

.company-section {
  position: relative;
  width: 100%;
  margin-top: var(--section-gap);
  overflow: hidden;
}

.company-bg {
  display: block;
  width: 100%;
  height: auto;
  border-radius: var(--card-radius);
}

.company-heart {
  position: absolute;
  top: clamp(18px, 6vw, 24px);
  left: clamp(14px, 4.8vw, 18px);
  width: 48%;
  max-width: clamp(168px, 52vw, 190px);
}

.company-info-card {
  position: absolute;
  left: clamp(12px, 3.8vw, 14px);
  right: clamp(38px, 14vw, 54px);
  bottom: clamp(42px, 13vw, 48px);
  padding: clamp(13px, 4vw, 16px) clamp(12px, 3.8vw, 14px) clamp(12px, 3.8vw, 14px);
  border-radius: clamp(14px, 4vw, 16px);
  background: rgba(255, 255, 255, 0.56);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-sizing: border-box;
  backdrop-filter: blur(2px);
}

.company-name {
  color: #222;
  font-size: clamp(14px, 4vw, 16px);
  font-weight: 700;
  line-height: 1.35;
}

.company-info-row {
  display: flex;
  align-items: center;
  margin-top: clamp(4px, 1.5vw, 5px);
  color: #1f1f1f;
  font-size: clamp(10px, 3.1vw, 12px);
  line-height: 1.2;
}

.company-info-row-address {
  align-items: flex-start;
}

.company-info-row span {
  flex: 1;
  min-width: 0;
  word-break: break-all;
}

.company-info-icon {
  width: clamp(14px, 4vw, 16px);
  height: clamp(14px, 4vw, 16px);
  margin-right: clamp(4px, 1.6vw, 6px);
  flex-shrink: 0;
}

.company-info-row-address .company-info-icon {
  margin-top: 1px;
}

.company-watch {
  position: absolute;
  left: 50%;
  bottom: clamp(18px, 6vw, 22px);
  width: 58%;
  max-width: clamp(208px, 66vw, 240px);
  transform: translateX(-50%);
}

.reward-claimed-modal-mask {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 5vw, 24px);
  background: rgba(0, 0, 0, 0.42);
  box-sizing: border-box;
}

.reward-claimed-modal {
  position: relative;
  width: min(82vw, 286px);
  border-radius: clamp(16px, 5vw, 18px);
  background: #fff;
  box-shadow: 0 18px 40px rgba(23, 31, 84, 0.22);
}

.reward-claimed-modal::after {
  content: '';
  position: absolute;
  left: 10%;
  right: 10%;
  bottom: clamp(-14px, -4vw, -10px);
  height: clamp(22px, 7vw, 26px);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.22);
  filter: blur(12px);
  z-index: -1;
}

.reward-claimed-modal-body {
  position: relative;
  min-height: var(--modal-height);
  border-radius: clamp(16px, 5vw, 18px);
  overflow: hidden;
}

.reward-claimed-modal-body::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgb(176, 223, 255) 0%, rgba(192, 232, 255, 0.92) 16%, rgba(221, 243, 255, 0.55) 30%, rgba(255, 255, 255, 0.12) 46%, rgba(255, 255, 255, 0) 58%);
  pointer-events: none;
}

.reward-claimed-modal-v {
  position: absolute;
  top: clamp(18px, 6vw, 24px);
  left: clamp(8px, 3vw, 10px);
  width: clamp(62px, 20vw, 72px);
  height: auto;
  opacity: 0.68;
  z-index: 2;
  pointer-events: none;
}

.reward-claimed-modal-content {
  position: relative;
  z-index: 2;
  min-height: var(--modal-height);
  padding-top: clamp(54px, 18vw, 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
}

.reward-claimed-modal-sorry {
  width: clamp(68px, 24vw, 76px);
  height: auto;
}

.reward-claimed-modal-text {
  width: min(68vw, 196px);
  max-width: 74%;
  margin-top: clamp(18px, 6vw, 24px);
  height: auto;
}

.reward-claimed-modal-btn {
  display: block;
  width: min(81vw, 232px);
  max-width: 88%;
  margin-top: clamp(64px, 21vw, 78px);
  height: clamp(42px, 13vw, 48px);
}

.reward-claimed-modal-rule-tip {
  width: min(34vw, 98px);
  max-width: 48%;
  margin-top: clamp(10px, 4vw, 16px);
  height: auto;
}

.points-claim-modal-mask {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 5vw, 24px);
  background: rgba(0, 0, 0, 0.42);
  box-sizing: border-box;
}

.points-claim-modal {
  position: relative;
  width: min(82vw, 286px);
  border-radius: clamp(16px, 5vw, 18px);
  background: #fff;
  box-shadow: 0 18px 40px rgba(23, 31, 84, 0.22);
}

.points-claim-modal::after {
  content: '';
  position: absolute;
  left: 10%;
  right: 10%;
  bottom: clamp(-14px, -4vw, -10px);
  height: clamp(22px, 7vw, 26px);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.22);
  filter: blur(12px);
  z-index: -1;
}

.points-claim-modal-body {
  position: relative;
  min-height: var(--modal-height);
  border-radius: clamp(16px, 5vw, 18px);
  overflow: hidden;
}

.points-claim-modal-body::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgb(255, 192, 208) 0%, rgba(255, 205, 218, 0.96) 16%, rgba(255, 223, 232, 0.74) 32%, rgba(255, 240, 245, 0.4) 48%, rgba(255, 255, 255, 0.14) 60%, rgba(255, 255, 255, 0) 74%);
  pointer-events: none;
}

.points-claim-modal-v {
  position: absolute;
  top: clamp(18px, 6vw, 24px);
  left: clamp(8px, 3vw, 10px);
  width: clamp(62px, 20vw, 72px);
  height: auto;
  opacity: 0.68;
  z-index: 2;
  pointer-events: none;
}

.points-claim-modal-content {
  position: relative;
  z-index: 2;
  min-height: var(--modal-height);
  padding-top: clamp(62px, 20vw, 74px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
}

.points-claim-modal-message {
  width: min(64vw, 184px);
  max-width: 68%;
  height: auto;
}

.points-claim-modal-score {
  margin-top: clamp(18px, 6vw, 24px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  line-height: 1;
}

.points-claim-modal-score-value {
  color: #ff5668;
  font-size: clamp(58px, 18vw, 76px);
  font-weight: 700;
  letter-spacing: -0.04em;
}

.points-claim-modal-score-unit {
  margin-left: clamp(4px, 1.4vw, 6px);
  margin-bottom: clamp(7px, 2vw, 10px);
  color: #23162f;
  font-size: clamp(22px, 7vw, 30px);
  font-weight: 500;
}

.points-claim-modal-btn {
  display: block;
  width: min(81vw, 232px);
  max-width: 88%;
  margin-top: clamp(36px, 12vw, 48px);
  height: clamp(42px, 13vw, 48px);
}

.points-claim-modal-rule-tip {
  width: min(34vw, 98px);
  max-width: 48%;
  margin-top: clamp(4px, 2vw, 8px);
  height: auto;
}

.points-rule-modal-mask {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: rgba(0, 0, 0, 0.48);
  box-sizing: border-box;
}

.points-rule-modal {
  position: relative;
  width: 100vw;
  max-width: 100vw;
  border-radius: clamp(24px, 7vw, 30px);
  background-color: #fff;
  background-image:
    radial-gradient(circle at top left, rgba(199, 234, 255, 0.95) 0%, rgba(199, 234, 255, 0.72) 28%, rgba(199, 234, 255, 0.3) 44%, rgba(199, 234, 255, 0) 58%),
    radial-gradient(circle at top right, rgba(255, 252, 239, 0.96) 0%, rgba(255, 252, 239, 0.76) 28%, rgba(255, 252, 239, 0.32) 44%, rgba(255, 252, 239, 0) 58%);
  background-repeat: no-repeat;
  padding: clamp(26px, 7vw, 34px) clamp(16px, 4.8vw, 24px) clamp(18px, 5vw, 24px);
  box-sizing: border-box;
}

.points-rule-modal-close {
  position: absolute;
  top: clamp(18px, 5vw, 24px);
  right: clamp(18px, 5vw, 24px);
  width: clamp(28px, 8vw, 34px);
  height: clamp(28px, 8vw, 34px);
  border: none;
  background: url('/static/images/aobang/error.png') center / contain no-repeat;
  padding: 0;
  cursor: pointer;
}

.points-rule-modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: clamp(6px, 1.6vw, 10px);
}

.points-rule-modal-header-img {
  width: min(58vw, 220px);
  max-width: 100%;
  height: auto;
}

.points-rule-modal-body {
  margin-top: clamp(18px, 4.8vw, 24px);
  padding: clamp(16px, 4.8vw, 22px) clamp(14px, 4.6vw, 20px) clamp(8px, 2.4vw, 12px);
  border-radius: clamp(18px, 5vw, 24px);
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.points-rule-modal-body-img {
  display: block;
  width: 100%;
  height: auto;
}

.code-error-modal-mask {
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 5vw, 24px);
  background: rgba(0, 0, 0, 0.42);
  box-sizing: border-box;
}

.code-error-modal {
  position: relative;
  width: min(82vw, 286px);
  border-radius: clamp(16px, 5vw, 18px);
  background: #fff;
  box-shadow: 0 18px 40px rgba(23, 31, 84, 0.22);
}

.code-error-modal::after {
  content: '';
  position: absolute;
  left: 10%;
  right: 10%;
  bottom: clamp(-14px, -4vw, -10px);
  height: clamp(22px, 7vw, 26px);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.22);
  filter: blur(12px);
  z-index: -1;
}

.code-error-modal-body {
  position: relative;
  min-height: clamp(220px, 64vw, 250px);
  border-radius: clamp(16px, 5vw, 18px);
  overflow: hidden;
}

.code-error-modal-body::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgb(176, 223, 255) 0%, rgba(192, 232, 255, 0.92) 16%, rgba(221, 243, 255, 0.55) 30%, rgba(255, 255, 255, 0.12) 46%, rgba(255, 255, 255, 0) 58%);
  pointer-events: none;
}

.code-error-modal-v {
  position: absolute;
  top: clamp(18px, 6vw, 24px);
  left: clamp(8px, 3vw, 10px);
  width: clamp(62px, 20vw, 72px);
  height: auto;
  opacity: 0.68;
  z-index: 2;
  pointer-events: none;
}

.code-error-modal-content {
  position: relative;
  z-index: 2;
  min-height: clamp(220px, 64vw, 250px);
  padding: clamp(44px, 14vw, 56px) clamp(24px, 7vw, 28px) clamp(28px, 8vw, 34px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
}

.code-error-modal-title {
  color: #1f2742;
  font-size: clamp(22px, 6.6vw, 28px);
  font-weight: 700;
  line-height: 1.35;
}

.code-error-modal-desc {
  margin-top: clamp(18px, 5.6vw, 24px);
  color: #1f2742;
  font-size: clamp(22px, 6.6vw, 28px);
  font-weight: 700;
  line-height: 1.35;
}
</style>



// WEBPACK FOOTER //
// src/components/Aobang/Result.vue